import { el } from 'redom';
import * as ReactDOM from 'react-dom';

import InputBox from 'generics/components/input-box';

import { render } from './description-editor';

class DescriptionInput {

  constructor(configuration) {

    this.value = configuration.value;
    this.onChange = configuration.onChange;
    this.eventId = configuration.eventId;
    this.mediaUploader = configuration.mediaUploader;
    this.readOnly = configuration.readOnly;
    this.placeholder = configuration.placeholder;

    this.contentFieldContainer = null;
    this.inputBox = null;

    this.el = this.renderContentEditorContainer();

  }

  renderReactContentEditor() {

    const self = this;
    const properties = {
      parentEntityId: this.eventId,
      onInputReady(editor, HelptapEditor) {},
      content: this.getDefaultContent(),
      onChange: this.handleContentChange.bind(this),
      onComplete() {},
      mediaUploader: this.mediaUploader,
      readOnly: this.readOnly,
      placeholder: this.placeholder,
      onFocus() {
        self.el.querySelector('.content-editor-element-container').classList.add('focused');
      },
      onBlur() {
        self.el.querySelector('.content-editor-element-container').classList.remove('focused');
      }
    };
    this.reactContentEditor = render(properties);

    return this.reactContentEditor;

  }

  renderDescriptionInput() {

    const component = this.renderReactContentEditor();

    ReactDOM.unmountComponentAtNode(this.contentFieldContainer);
    ReactDOM.render(component, this.contentFieldContainer);

  }

  renderContentEditorContainer() {

    this.contentFieldContainer = el('.form-field-container', []);

    this.renderDescriptionInput();

    this.inputBox = new InputBox({ input: this.contentFieldContainer });

    return el('.editor-container', [this.inputBox]);

  }

  getDefaultContent() {

    return this.value;

  }

  handleContentChange(content) {

    this.clearError();

    this.onChange(content);

  }

  setError(error) {

    this.inputBox.setError(error);

  }

  clearError() {

    this.inputBox.clearError();

  }

}

export default DescriptionInput;